import React, { FC, useState } from "react";
import {
  FormControl,
  Grid,
  InputAdornment,
  Link,
  Modal,
  OutlinedInput,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { useHistory } from "react-router-dom";

interface Props {
  claimTemplates: any[];
  patient_id: string;
  modalOpen: boolean;
  setModalOpen: any;
  encounterId: string;
  // setRenderingKey: any;
}

const ChooseClaimTemplateModal: FC<Props> = ({
  claimTemplates,
  patient_id,
  modalOpen,
  setModalOpen,
  encounterId,
}) => {
  const history = useHistory();

  const [selectedClaimTemplate, setSelectedClaimTemplate] = useState<
    any | null
  >(null);
  const [searchKey, setSearchKey] = React.useState<string>(undefined);

  const handleOptionSelection = () => {
    history.push(
      `/patient_reports/${patient_id}/claims_builder?encounterBillingId=${encounterId}&selected_template=${selectedClaimTemplate.id}`
    );
  };

  console.log("selectedTemplate", selectedClaimTemplate);

  const filteredTemplates = claimTemplates?.filter((template) => {
    if (!searchKey) return true;
    const key = searchKey.toLowerCase();
    return (
      template.title?.toLowerCase().includes(key) ||
      template.subtext?.toLowerCase().includes(key)
    );
  });

  return (
    <Modal open={modalOpen} className="follow-up-modal">
      <div className="paper" style={{ width: "900px", padding: "0px" }}>
        <div className="paperInner" style={{ padding: "0px" }}>
          <Grid
            container
            className="fum-header-container"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1 className="fum-header">Choose Claim Template</h1>
            <Link
              onClick={() => setModalOpen(false)}
              style={{ color: "black", paddingRight: "20px" }}
            >
              <CloseIcon />
            </Link>
          </Grid>
          <div className="divider-orange" style={{ margin: "0px" }}></div>

          <Grid
            container
            style={{ padding: "24px" }}
            alignItems={"center"}
            spacing={4}
          >
            <Grid
              item
              xs={12}
              md={5}
              style={{
                position: "relative",
                marginLeft: "0px !important",
              }}
            >
              <FormControl sx={{ width: "100%" }} variant="outlined">
                <OutlinedInput
                  id="outlined-adornment-weight"
                  placeholder="Search Templates"
                  endAdornment={
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  style={{ backgroundColor: "#EFE9E7", border: "none" }}
                  value={searchKey}
                  onChange={(event) => {
                    setSearchKey(event.target.value);
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={7} className="subdued-text">
              {"Can't find the template you're looking for? Create one in the"}{" "}
              <a href="/claim-template-builder">Claim Template Builder</a>
            </Grid>
          </Grid>

          <TableContainer
            className="template-container"
            sx={{ maxHeight: "50vh" }}
          >
            <Table className="no-border-table">
              <TableHead sx={{ borderBottom: "1.5px solid black" }}>
                <TableRow>
                  <TableCell width={"1%"} />
                  <TableCell
                    className="bold-font-face nowrap-header"
                    style={{ cursor: "pointer" }}
                    sx={{ pl: "0" }}
                  >
                    <strong>Title</strong>
                  </TableCell>
                  <TableCell className="nowrap-header bolder-text">
                    Subtext
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredTemplates?.map((claimTemplate) => (
                  <TableRow key={claimTemplate?.id}>
                    <TableCell
                      width={"1%"}
                      align="right"
                      sx={{ pr: 0, pl: "24px" }}
                    >
                      <Radio
                        checked={selectedClaimTemplate?.id === claimTemplate.id}
                        value={claimTemplate.id}
                        onChange={() => setSelectedClaimTemplate(claimTemplate)}
                      />
                    </TableCell>
                    <TableCell sx={{ pl: "0" }}>
                      {claimTemplate.title}
                    </TableCell>
                    <TableCell>{claimTemplate.subtext}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "30px" }}
          >
            <Grid
              item
              xs={4}
              className="cancel-link-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Link className="cancel-link" onClick={() => setModalOpen(false)}>
                Cancel
              </Link>
            </Grid>
            <Grid item xs={4} className="confirm-btn-container">
              <Link
                onClick={handleOptionSelection}
                className="confirm-btn"
                style={{ width: "135px" }}
              >
                Continue
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default ChooseClaimTemplateModal;
